// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0be7813e","239":"11e38f79","453":"7e931588","455":"6297e58b"}[chunkId] + ".chunk.js";
};